import {CheckUtils} from "od-ts";

export class NameUtils {

  static getInitials(value: string): string {
    var result = "";
    if (CheckUtils.isEmpty(value)) return result;

    var names: Array<string> = value.split(/[.-\s]/);
    for (let name of names) {
      result += name.charAt(0);
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/utils/name-utils.ts